import { render, staticRenderFns } from "./Configuracion.vue?vue&type=template&id=5cbbdc2e&scoped=true&"
import script from "./Configuracion.vue?vue&type=script&lang=js&"
export * from "./Configuracion.vue?vue&type=script&lang=js&"
import style0 from "./Configuracion.scss?vue&type=style&index=0&id=5cbbdc2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbbdc2e",
  null
  
)

export default component.exports